import { createContext } from "react";

export interface FormContextValue {
  loading?: boolean;
}

export interface StepperContextValue {
  activeStep: number;
  moveNext: () => void;
  moveBack: () => void;
  moveStart: () => void;
  skipStep: () => void;
  hasNext: () => boolean;
}

export interface DynamicLocalizationContextValue {
  lang?: string;
}

export const FormContext = createContext<FormContextValue | null>(null);
export const StepperContext = createContext<StepperContextValue | null>(null);
export const DynamicLocalizationContext = createContext<DynamicLocalizationContextValue | null>(
  null
);
